import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LiveIcon from "../../../assets/Icon/live 1.png";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import QnAStarNav from "../../../Layouts/Partial/QnAStarNav";
import axios from "axios";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";
const QnaDashboard = () => {
  const [event_data, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get(`/api/star/qna_live`).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
      }
    });
  }, []);

  return (
    <>
      <div className="AS">
        <QnAStarNav />
        {buffer ? (
          <LoaderPost />
        ) : (
          <>
            {event_data === 0 ? (
              <div className="container-fluid">
                <div
                  className="card card-bg"
                  style={{ border: "2px solid yellow" }}
                >
                  <div className="card-body">
                    <h5 className="text-light">
                      {" "}
                      <img
                        src={LiveIcon}
                        alt=""
                        className="img-fluid mx-2"
                      />{" "}
                      Live QnA profile
                    </h5>
                    <div className="container text-center">
                      <i
                        style={{ color: "#ffc107" }}
                        className="fas fa-box-open fa-4x my-2"
                      ></i>
                      <h2 className="fw-bold text-light">No Data here</h2>
                      <h5 className="text-light my-3">
                        Create Default QnA Profile Now!
                      </h5>
                      {/* <p className=" my-2 text-muted">
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                </p> */}
                      <Link to="/superstar/qna/create">
                        <button className="btn btn-warning px-5 py-2 mb-5">
                          Create Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="card card-bg head-line mb-2">
                  <div className="text-light d-flex justify-content-center p-2">
                    <div className="faTrophy">
                      <i className="fas fa-trophy"></i>
                    </div>
                    <h4 className="mx-3 text-white p-2">
                      <span className="livechat-card-small">All QnA</span>
                    </h4>
                  </div>
                </div>
                <AllModuleData
                  data={event_data}
                  urlLink={`/superstar/qna/details`}
                  qna={"true"}
                />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default QnaDashboard;
